import { createContext, useCallback, useContext, useMemo, useRef } from "react";

const ApprovalCommentFieldHintContext = createContext({
  registerOnClose: () => () => {},
  closeApprovalFieldHint: () => {},
});

export const ApprovalCommentFieldHintProvider = ({ children }) => {
  const onCloseRef = useRef(null);

  const registerOnClose = useCallback((onClose) => {
    onCloseRef.current = onClose;

    return () => {
      if (onCloseRef.current === onClose) {
        onCloseRef.current = null;
      }
    };
  }, []);

  const closeApprovalFieldHint = useCallback(() => {
    onCloseRef.current?.();
  }, []);

  const value = useMemo(
    () => ({
      registerOnClose,
      closeApprovalFieldHint,
    }),
    [registerOnClose, closeApprovalFieldHint]
  );

  return (
    <ApprovalCommentFieldHintContext.Provider value={value}>
      {children}
    </ApprovalCommentFieldHintContext.Provider>
  );
};

//eslint-disable-next-line
export const useApprovalCommentFieldHint = () =>
  useContext(ApprovalCommentFieldHintContext);
